import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const featuredCategories = categories.slice(0, 4);

const featuredImages: Record<string, string> = {
  'cat-shoes-01': 'https://readdy.ai/api/search-image?query=Top-down%20lifestyle%20shot%20of%20a%20person%20walking%20on%20a%20sunlit%20european%20cobblestone%20street%20wearing%20colorful%20canvas%20sneakers%2C%20warm%20afternoon%20shadows%2C%20rustic%20stone%20texture%2C%20casual%20fashion%20photography%2C%20warm%20summer%20vibes%2C%20no%20text&width=500&height=400&seq=feat-shoes-v2&orientation=landscape',
  'cat-hoodies-02': 'https://readdy.ai/api/search-image?query=Person%20wearing%20an%20oversized%20cream%20knit%20hoodie%20sitting%20on%20a%20linen%20sofa%20holding%20a%20handmade%20ceramic%20mug%20with%20steaming%20coffee%2C%20cozy%20scandinavian%20apartment%20interior%20with%20birch%20wood%20floors%2C%20soft%20morning%20light%2C%20lifestyle%20photography%2C%20no%20text&width=500&height=400&seq=feat-hoodies-v2&orientation=landscape',
  'cat-tshirts-03': 'https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20t-shirt%20hanging%20on%20a%20thin%20rope%20clothesline%20in%20a%20garden%20setting%2C%20golden%20sunset%20bokeh%20in%20the%20background%2C%20warm%20amber%20light%20filtering%20through%20trees%2C%20peaceful%20summer%20evening%20atmosphere%2C%20lifestyle%20photography%2C%20no%20text&width=500&height=400&seq=feat-tshirts-v2&orientation=landscape',
  'cat-jackets-04': 'https://readdy.ai/api/search-image?query=Vintage%20indigo%20denim%20jacket%20casually%20draped%20over%20the%20seat%20of%20a%20vintage%20bicycle%20in%20a%20sunlit%20mediterranean%20courtyard%20with%20terracotta%20pots%20and%20climbing%20ivy%2C%20warm%20golden%20afternoon%20light%2C%20travel%20lifestyle%20photography%2C%20no%20text&width=500&height=400&seq=feat-jackets-v2&orientation=landscape',
};

export default function FeaturedGrid() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Najnowsze Zestawienia
            </h2>
            <p className="mt-2 text-foreground-600 text-sm md:text-base">
              Popularne kategorie wybierane przez naszych użytkowników
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredCategories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-lg overflow-hidden cursor-pointer bg-white"
            >
              <div className="aspect-[5/4] overflow-hidden">
                <img
                  src={featuredImages[cat.imageSeq]}
                  alt={`Kakobuy Spreadsheet — ${cat.namePl}`}
                  title={`Kakobuy Spreadsheet — ${cat.namePl}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading text-lg font-semibold text-foreground-900">{cat.namePl}</h3>
                <p className="text-foreground-500 text-sm mt-1">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between mt-10 gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-foreground-600 text-sm font-label hover:text-foreground-900 transition-colors cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </span>
            Wróć do Strony Głównej
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-label font-bold text-sm rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all"
          >
            Zobacz na Kaspreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}